module.exports = __webpack_public_path__ + "static/Polaroid_Pin-11476f82af268202bb75794046c23118.png";